import { render, staticRenderFns } from "./admin-menu-lg.vue?vue&type=template&id=4effe502&scoped=true&"
import script from "./admin-menu-lg.vue?vue&type=script&lang=js&"
export * from "./admin-menu-lg.vue?vue&type=script&lang=js&"
import style0 from "./admin-menu-lg.vue?vue&type=style&index=0&id=4effe502&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4effe502",
  null
  
)

export default component.exports